import { Resource } from '../Resource';
import { deviceMutationExternalInvalidationKeys } from './devices';
import { plotMutationExternalInvalidationKeys } from './plots';
import { stationsMutationExternalInvalidationKeys } from './stations';
const rootPath = 'bbox';
const fromRaw = ({ bbox }) => bbox;
const boundingBoxes = Resource((requesterBuilder) => {
    const createGetBoundingBox = (resource) => (query) => {
        const newRequester = requesterBuilder({
            path: `${rootPath}/${resource}`,
            requestCtx: {
                transform: fromRaw,
                params: {
                    query: {
                        organization: query?.organizationId,
                        universe: query?.universe
                    }
                }
            }
        });
        if (resource === 'plots') {
            plotMutationExternalInvalidationKeys.add(newRequester.key[0]);
        }
        else if (resource === 'devices') {
            deviceMutationExternalInvalidationKeys.add(newRequester.key[0]);
        }
        else if (resource === 'plots_and_stations') {
            // adding a device also create a station so we need to add it to the list to invalidate on device edition
            deviceMutationExternalInvalidationKeys.add(newRequester.key[0]);
            plotMutationExternalInvalidationKeys.add(newRequester.key[0]);
            stationsMutationExternalInvalidationKeys.add(newRequester.key[0]);
        }
        return newRequester;
    };
    return {
        plots: {
            getBoundingBox: createGetBoundingBox('plots')
        },
        devices: {
            getBoundingBox: createGetBoundingBox('devices')
        },
        plotsAndStations: {
            getBoundingBox: createGetBoundingBox('plots_and_stations')
        }
    };
});
export default boundingBoxes;
